"use client";

import type { ReactNode } from "react";

import { AuthInitializer } from "./auth-initializer";
import { QueryProvider } from "./query-provider";
import { ThemeProvider } from "./theme-provider";
import { BackToTop } from "@/components/common";
import { Toaster } from "@/components/ui";

export const RootProviders = ({ children }: { children: ReactNode }) => {
  return (
    <QueryProvider>
      <ThemeProvider
        attribute="class"
        defaultTheme="system"
        enableSystem
        disableTransitionOnChange
      >
        <AuthInitializer>{children}</AuthInitializer>
        <BackToTop />
      </ThemeProvider>
      <Toaster
        position="bottom-right"
        toastOptions={{ duration: 3000 }}
        richColors
      />
    </QueryProvider>
  );
};
